<div id = "footer-section">
    <div id = "footer-admin-menu-address" style="grid-area: 'admin-menu-address';">
        Jelenlegi szerver cím: {{ selectedServerAddress }}
    </div>
    <div id = "footer-admin-menu-revision" style="grid-area: 'admin-menu-revision';justify-self:end">
        Revíziószám: {{ revisionNumber }}
    </div>
</div>
